import axios from "axios";
import store from "@/store";

// You can use your own logic to set your local or production domain
const baseDomain = process.env.VUE_APP_API_BASE_URL || "http://localhost:9000";
// console.log("env: ", process.env.VUE_APP_API_BASE_URL);
// const baseDomain = 'http://0.0.0.0:9000'
// The base URL is empty this time due we are using the jsonplaceholder API
const baseURL = `${baseDomain}`;
const opt = {
  baseURL,
  timeout: 10000,
  headers: { "Content-Type": "application/json" }
};
const api = axios.create(opt);

api.interceptors.request.use(
  function(config) {
    const token = store.getters["auth/token"];
    // const token = localStorage.getItem('tokenDev')
    // console.log('Token: ', token)
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (401 === error.response.status) {
      store.commit("auth/logout");
    }
    return Promise.reject(error);
  }
);
export default api;
